<template>
  <div>
    <a-drawer
      :title="title"
      :maskClosable="true"
      :width="800"
      placement="right"
      :closable="true"
      @close="handleCancel"
      :visible="visible"
      style="overflow: auto; padding-bottom: 53px"
    >
      <a-spin :spinning="confirmLoading">
        <a-form :form="form">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="类型"
          >
            <a-select
              v-decorator="[
                'type',
                { rules: [{ required: true, message: '请选择类型' }] },
              ]"
              placeholder="请选择类型"
            >
              <a-select-option :value="1" :key="1"> 订阅号 </a-select-option>
              <a-select-option :value="2" :key="2"> 服务号 </a-select-option>
              <a-select-option :value="3" :key="3"> 小程序 </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="名字"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="[
                'name',
                { rules: [{ required: true, message: '请输入名字' }] },
              ]"
              placeholder="请输入名字"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="原始ID"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="[
                'sourceId',
                { rules: [{ required: true, message: '请输入原始ID' }] },
              ]"
              placeholder="请输入原始ID"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="appId"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="[
                'appId',
                { rules: [{ required: true, message: '请输入appId' }] },
              ]"
              placeholder="请输入appId"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="appSecret"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="[
                'appSecret',
                { rules: [{ required: true, message: '请输入appSecret' }] },
              ]"
              placeholder="请输入appSecret"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="Token"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="['token']"
              placeholder="请输入Token"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="AESKey"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="['aesKey']"
              placeholder="请输入EncodingAESKey"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="消息格式"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-select
              v-decorator="[
                'msgFormat',
                { rules: [{ required: true, message: '请选择消息格式' }] },
              ]"
              placeholder="请选择消息格式"
            >
              <a-select-option :value="'xml'" :key="'xml'">
                XML
              </a-select-option>
              <a-select-option :value="'json'" :key="'json'">
                JSON
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="是否认证"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-select
              v-decorator="[
                'verified',
                { rules: [{ required: true, message: '请选择是否认证' }] },
              ]"
              placeholder="请选择是否认证"
            >
              <a-select-option :value="1" :key="1"> 是 </a-select-option>
              <a-select-option :value="0" :key="0"> 否 </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="Icon"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <!-- <j-image-upload
            class="avatar-uploader"
            text="上传"
            v-model="model.iconList"
          ></j-image-upload> -->
            <UploadImage
              :imgUrl="bigPicurl"
              v-decorator="['icon']"
              @handleFileList="handleFileList"
            />
          </a-form-item>
          <a-form-item
            label="状态"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-select
              v-decorator="[
                'status',
                { rules: [{ required: true, message: '请选择状态' }] },
              ]"
              placeholder="请选择状态"
            >
              <a-select-option :value="1" :key="1"> 正常 </a-select-option>
              <a-select-option :value="0" :key="0"> 冻结 </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
      <div class="drawer-bootom-button">
        <a-popconfirm
          title="确定放弃编辑？"
          @confirm="handleCancel"
          okText="确定"
          cancelText="取消"
        >
          <a-button style="margin-right: 0.8rem">取消</a-button>
        </a-popconfirm>
        <a-button @click="handleOk" type="primary" :disabled="isDisable"
          >提交</a-button
        >
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { postAction } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'WechatAppModal',
  components: {
    JDate,
    JImageUpload,
    UploadImage,
  },
  data() {
    return {
      imgFile: {},
      bigPicurl: '',
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      isDisable: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_WECHAT + '/wechatApp/add',
        edit: process.env.VUE_APP_CMS_WECHAT + '/wechatApp/edit',
      },
    };
  },
  created() {},
  methods: {
    handleFileList(file) {
      console.warn(typeof file.fileName)
      this.imgFile = file;
      this.bigPicurl = file.fileUrl;
      this.form.setFieldsValue({
         icon:file.fileName
      })
    },
    add() {
      this.bigPicurl = '';
      this.edit({});
    },
    edit(record) {
      console.log(record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            'icon',
            'type',
            'sourceId',
            'token',
            'aesKey',
            'msgFormat',
            'status',
            'appId',
            'appSecret',
            'verified'
          )
        );
      });
    },
    close() {
      if (this.title == '新增') {
        this.$emit('close');
      }
      this.visible = false;
    },
    handleOk() {
      const that = this;
      debugger
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
            that.isDisable = true;
          } else {
            httpurl += this.url.edit;
            method = 'post';
            that.isDisable = true;
          }
          let formData = Object.assign(this.model, values);
          console.warn('表单提交数据', values);

          postAction(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                that.close();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.isDisable = false;
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'name',
          'type',
          'sourceId',
          'token',
          'aesKey',
          'msgFormat',
          'status',
          'delFlag',
          'appId',
          'appSecret',
          'verified'
        )
      );
    },
  },
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
